import { render, staticRenderFns } from "./SelectedPartner.vue?vue&type=template&id=01ace52d"
import script from "./SelectedPartner.vue?vue&type=script&lang=js"
export * from "./SelectedPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports